import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { registerLicense } from '@syncfusion/ej2-base';
import App from './App';

// Register Syncfusion license key (from env variable)
registerLicense(import.meta.env.VITE_SYNCFUSION_LICENSE_KEY || '');

import '@syncfusion/ej2-base/styles/material.css';
import '@syncfusion/ej2-buttons/styles/material.css';
import '@syncfusion/ej2-calendars/styles/material.css';
import '@syncfusion/ej2-dropdowns/styles/material.css';
import '@syncfusion/ej2-inputs/styles/material.css';
import '@syncfusion/ej2-navigations/styles/material.css';
import '@syncfusion/ej2-popups/styles/material.css';
import '@syncfusion/ej2-schedule/styles/material.css';

// monday.com Vibe Design System – provides all CSS variable tokens
// (colors, typography, spacing, shadows) for light/dark/black themes.
// This is the official way to expose monday.com design tokens at :root.
import 'monday-ui-style/dist/index.min.css';

import './app.css';
import './styles/scheduler.css';
import './styles/itembox.css';
import './styles/detail-panel.css';
import './styles/settings.css';
import './styles/capacity.css';
import './styles/holiday.css';
import './styles/worklog.css';
import './styles/views.css';
import './styles/calendar.css';
import './styles/filter.css';
import './styles/multiselect.css';
import './styles/timetracking.css';
import './styles/leave.css';
import './styles/recurring.css';
import './styles/item-search-panel.css';
import './styles/mapping-wizard.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
);
